import { render } from "./ExpertiseComponent.vue?vue&type=template&id=b6998756"
import script from "./ExpertiseComponent.vue?vue&type=script&lang=js"
export * from "./ExpertiseComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__